module.exports = __webpack_public_path__ + "images/emoji/sunflower.492eb39fe09f52c27ea4.png";